/* eslint-disable react/no-unescaped-entities */
import { type Dispatch, type FC, type SetStateAction } from 'react'
import { type Control } from 'react-hook-form'

import { Button, Dialog, Stack, Typography } from '@mui/material'
import { LinkText } from '@core/components/common/Button'
import { ArrowLeftIcon } from '@core/components/icons'
import { MobileWrapper } from '@core/components/layout/MobileWrapper'
import { RHFCustomCheckbox } from '@core/components/ui'
import { useLayout } from '@core/contexts/layout'
import { colors } from '@core/helpers'

interface Props {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  control: Control<any, any>
  isChecked: boolean
  terms?: string
}

export const TermConditionsModal: FC<Props> = ({ open, setOpen, control, isChecked }) => {
  const { isMobile } = useLayout()

  const onClose = () => {
    setOpen(false)
  }

  return (
    <Dialog
      PaperProps={{ sx: { borderRadius: isMobile ? 0 : undefined } }}
      open={open}
      fullScreen={isMobile}
      onClose={onClose}
    >
      <Stack maxWidth='60rem' px='3rem' py='1rem'>
        <MobileWrapper mb={0} position='relative' maxWidth='100%'>
          <LinkText
            typographyProps={{
              fontWeight: 600
            }}
            customIcon={(_, size) => <ArrowLeftIcon size={size} color={colors.primary_darkest} />}
            text='Atrás'
            onClick={onClose}
            iconUbi='left'
            color={colors.primary_darkest}
            styleContainer={{
              marginTop: '2.4rem',
              marginBottom: '2.4rem'
            }}
          />

          <Stack gap='0.5rem'>
            <Typography variant='body3'>
              Los siguientes términos y condiciones de uso (en adelante, "Términos") son un acuerdo
              legal entre el usuario y Centros de Salud Peruanos S.A.C., RUC N° con RUC
              N°20602393934, con domicilio en Jirón Carlos Villarán N°611, Urbanización Santa
              Catalina, Distrito de La Victoria, Provincia y Departamento de Lima, Perú (en adelante
              "CSP" o "nosotros", " nos” o "nuestro "), para establecer el marco legal y contractual
              aplicable al registro, uso, baja o interacción en la plataforma ofrecida por CSP para
              el acceso a los servicios que presta CLÍNICA AVIVA y todas las aplicaciones móviles o
              sitios web que pertenecen, operan, tienen licencia o están bajo el control de CSP (en
              adelante, “Aplicación móvil”, “Aplicaciones móviles”, “Sitio Web” o "Sitios Web"). AL
              ACCEDER O UTILIZAR LAS APLICACIONES O SITIOS WEB, EL USUARIO SE COMPROMETE A RESPETAR
              ESTOS TÉRMINOS Y NUESTRA POLÍTICA DE PRIVACIDAD. SI NO ESTÁ DE ACUERDO CON ESTOS
              TÉRMINOS, NO ACCEDA NI UTILICE LAS APLICACIONES O LOS SITIOS WEB.
            </Typography>
            <Typography variant='body3'>
              Al utilizar el Sitio Web o Aplicaciones Móviles, usted declara y garantiza que: usted
              tiene el poder legal y la autoridad para aceptar y estar sujeto a estos Términos; y,
              si nos ha proporcionado información como consecuencia del uso del Sitio Web, dicha
              información es verdadera y precisa.
            </Typography>
            <Typography variant='body3'>
              Facilitar información falsa, engañosa o incorrecta puede dar lugar a responsabilidades
              tanto civiles como penales. Si tienes dudas al respecto, te recomendamos que consultes
              con tu asesor legal. El acceso y utilización del Sitio Web y Aplicaciones Móviles
              implica la declaración expresa del usuario de conocer y aceptar plenamente todas las
              disposiciones, normas, instrucciones, responsabilidades y políticas contenidas en los
              presentes Términos. En consecuencia, el usuario debe leer detenidamente los presentes
              Términos cada vez que acceda al Sitio Web, Aplicaciones Móviles y Servicios, pues
              podrían sufrir variaciones o actualizaciones sin previo aviso, en atención a nuevos
              requerimientos legales o por necesidades internas para cumplir con las mejores
              prácticas de negocio.
            </Typography>
          </Stack>
          <Stack gap='2.4rem' py='2.4rem' bgcolor={colors.white} position='sticky' bottom={0}>
            <RHFCustomCheckbox
              control={control}
              name='term_conditions'
              label='Acepto los términos y condiciones'
            />
            <Button onClick={onClose} disabled={!isChecked} sx={{ display: 'flex' }}>
              Aceptar términos y condiciones
            </Button>
          </Stack>
        </MobileWrapper>
      </Stack>
    </Dialog>
  )
}
